import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { generateChecksum } from '../middleware/generateChecksum';

export const employmentApi = createApi({
    reducerPath: 'employmentApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL + '/v2/api/',
    }),
    endpoints: (builder) => ({
        sendVerificationOTP: builder.mutation({
            query: (data) => {
                const body = {
                    mode: 'sendVerifyEmailOtp',
                    email: data.email,
                    email_type: 2,
                }
                const checksum = generateChecksum(body)
                body.checksum = checksum

                return {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        Accept: 'application/json',
                        secret: data.scrt,
                        jwt_token: data.jwt_token,
                    },
                    body: new URLSearchParams(body).toString(),
                };
            },
        }),
        verifySentOTP: builder.mutation({
            query: (data) => {
                const body = {
                    mode: 'verifyEmailOtp',
                    email: data.email,
                    email_type: 2,
                    otp: data.otp
                }
                const checksum = generateChecksum(body)
                body.checksum = checksum

                return {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        Accept: 'application/json',
                        secret: data.scrt,
                        jwt_token: data.jwt_token,
                    },
                    body: new URLSearchParams(body).toString(),
                };
            },
        }),
        verifyUAN: builder.mutation({
            query: (data) => {
                const body = {
                    mode: 'verify_uan',
                    uan: data.uan,
                }
                const checksum = generateChecksum(body)
                body.checksum = checksum

                return {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        Accept: 'application/json',
                        secret: data.scrt,
                        jwt_token: data.jwt_token,
                    },
                    body: new URLSearchParams(body).toString(),
                };
            },
        }),
        updateReferences: builder.mutation({
            query: (data) => {
                const body = {
                    mode: 'customer-refrence',
                    customer_refrence1: data.customer_refrence1,
                    refrence_mobile1: data.refrence_mobile1,
                    customer_refrence2: data.customer_refrence2,
                    refrence_mobile2: data.refrence_mobile2,
                }
                const checksum = generateChecksum(body)
                body.checksum = checksum

                return {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        Accept: 'application/json',
                        secret: data.scrt,
                        jwt_token: data.jwt_token,
                    },
                    body: new URLSearchParams(body).toString(),
                };
            },
        }),
    }),
});

export const {
    useSendVerificationOTPMutation,
    useVerifySentOTPMutation,
    useVerifyUANMutation,
    useUpdateReferencesMutation
} = employmentApi;
